<template>
  <div class="primary-container with-new-navbar nuxt-dorado-container dorado-wrapper">
    <GoogleOneTap v-if="displayOneTap" />

    <div
      v-if="previewCampaign"
      :style="campaignStyle"
    >
      Previewing {{ previewCampaignName }}
      <a
        class="preview-campaign"
        href="?preview_campaign=reset"
        title="Exit campaign preview"
      >&#10006;</a>
    </div>

    <div
      v-if="showOverlay"
      id="sumo-main-overlay"
      class="active"
    />

    <!-- Nav Bar -->
    <NavBarHeader
      :group="browse.group"
    />

    <main :class="{ 'mt-0': !allowStickyHeader }">
      <div>
        <form
          v-if="isHijackedUser"
          :action="getReleaseUserUrl()"
          method="POST"
        >
          <p class="float-left ml-5 mr-1">
            You are currently working on behalf of {{ getCurrentUser.username }}
          </p>
          <input
            type="hidden"
            name="csrfmiddlewaretoken"
            :value="csrf"
          >
          <button>Release user</button>
        </form>
      </div>
      <nuxt />
    </main>
    <!-- ******* FOOTER ******* -->
    <Footer />

    <ScrollToTop />
  </div>
</template>
<script>
import BasePageMixin from '~/mixins/base-page-mixin';
import ScrollToTop from '../components/common/ScrollToTop.vue';
import Footer from '../components/common/Footer.vue';
import NavBarHeader from '../components/common/NavBarHeader.vue';
import GoogleOneTap from '../components/common/GoogleOneTap.vue';

// only load ui goodies in the browser
if (process.browser) {
  window.dataLayer = window.dataLayer || [];
  window.bannersJs = window.bannersJs || [];
}

export default {
  components: {
    ScrollToTop,
    Footer,
    NavBarHeader,
    GoogleOneTap,
  },
  mixins: [BasePageMixin],
};
</script>
<style lang="scss">
  @import '~/styles/dorado';
  @import '~/styles/utils/breakpoints';

  // TODO:: Use dorado color naming below and in other files

  .preview-campaign {
    margin-left: 10px;
    color: #2980b9;
  }

  .primary-container {
    display: grid;
    font-size: 14px;
    grid-template-rows: auto 1fr auto;
    min-height: 100%;
    transition: margin-top 0.2s ease-in-out;
  }

  .sumo-browse-main {
    min-width: 320px;
    max-width: 2000px;
    padding: 0 30px;
  }

  @media (min-width: 2000px) {
    .sumo-browse-main {
      width: 100%;
      margin: auto;
    }
  }

  @include media-breakpoint-down(md) {
    .sumo-browse-main {
      padding: 0 20px;
    }
  }
</style>
